export default {
  invoices: state => state.invoices,
  invoice: state => state.invoice,
  newInvoice: state => state.newInvoice,
  newShipment: state => state.newShipment,
  getTrackingInfo: state => state.trackingInfo
}
